module.exports = __webpack_public_path__ + "static/price-compare-b440634af12478a339168c6a39766497.png";